import { render, staticRenderFns } from "./BtnDeflatorItemContrato.vue?vue&type=template&id=8a977fee&"
import script from "./BtnDeflatorItemContrato.vue?vue&type=script&lang=js&"
export * from "./BtnDeflatorItemContrato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports